import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ─── Réveil anticipé du backend (Render free tier) ─────────────────────────
// Le backend s'endort après 15 min d'inactivité et met jusqu'à 60s à
// redémarrer. On envoie un ping "fire and forget" vers /api/health dès
// l'ouverture du site, en parallèle du rendu React, pour que le serveur
// commence à se réveiller le plus tôt possible — au lieu d'attendre que la
// page Home lance ses vraies requêtes de produits.
try {
  const rawUrl =
    process.env.REACT_APP_API_URL || 'https://sunumarket-api.onrender.com/api';
  const apiOrigin = rawUrl.replace(/\/api\/?$/, '');
  fetch(`${apiOrigin}/api/health`).catch(() => {});
} catch {
  // silencieux : ce ping est une optimisation, pas une dépendance critique
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);